import React from 'react';
import {SnackbarServiceProvider} from '../SnackbarService';

/**
 * wrap component in snack bar provider
 * @example
	const WrappedComponenet = withSnackbar(Componenet);
 */
export const withSnackbar = function <C extends React.ElementType>(
	Component: C,
) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<SnackbarServiceProvider>
				<Component {...props} />
			</SnackbarServiceProvider>
		);
	};
};

export default withSnackbar;
